import type { IconData } from '@stacksjs/iconify-core'

export const arrowThickTop: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M352.062 496h-192V295.993L16.047 296l.037-38.688L256.318 17.364L496 257.7v38.278l-143.938.006Zm-160-32h128V263.984l137.007-.006L256.274 62.636L54.672 264l137.39-.008Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default arrowThickTop
